define([
	"dojo/_base/declare",
	"csi/action/DeleteController"
], function(declare,DeleteController) {

	return declare(DeleteController, {
		// Boolean: indicates that action works on view refNode
		bRefNode: true,

		postProcessSuccess: function() {	
			// summary: remove associated DOM nodes
			if (this.refNode) {
				this.widget.deleteRow(this.refNode);
			}

			this.inherited(arguments);
		}
	});
});